// extracted by mini-css-extract-plugin
export default {"mn-permission-page":"index_mn-permission-page__mLyGZ"};